<% var component = new Anvil.models.components.RadioList(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col-auto pr-0">
	<% for (let i = 0; i < field.options.length; i++) { %>
	<div class="custom-control custom-radio">
		<input type="radio" class="custom-control-input" id="<%= form.name %>_<%= field.name %>_<%= i %>" name="<%= field.name %>" value="<%= i %>" <% if (field.name in form.data && Array.isArray(form.data[field.name]) && form.data[field.name].includes(i)) { %>checked<% } %> />
		<label class="custom-control-label" for="<%= form.name %>_<%= field.name %>_<%= i %>"><%= field.options[i] %></label>
	</div>
	<% } %>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<% for (let i = 0; i < field.options.length; i++) { %>
		<div class="custom-control custom-radio">
			<input type="radio" class="custom-control-input" id="<%= form.name %>_<%= field.name %>_<%= i %>" name="<%= field.name %>" value="<%= i %>" <% if (field.name in form.data && Array.isArray(form.data[field.name]) && form.data[field.name].includes(i)) { %>checked<% } %> />
			<label class="custom-control-label" for="<%= form.name %>_<%= field.name %>_<%= i %>"><%= field.options[i] %></label>
		</div>
		<% } %>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
